import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import ContactSet from "../../../Contacts/ContactSet";
import {
  closeModal,
  selectCurrentModal,
  selectModalData,
} from "../../../store/slices/modalsSlice";

export default function ContactSetModal() {
  const show = useSelector(selectCurrentModal) === "contactSet";
  const { uuid = null, onClose = () => null } =
    useSelector(selectModalData) || {};
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
    onClose();
  };

  return (
    <Modal
      size="xl"
      // centered
      show={show}
      onHide={handleClose}
      scrollable
      animation={false}
      backdropClassName="z-contact-set-backdrop contact-set-modal-backdrop"
      className="z-contact-set contact-set-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <ContactSet uuid={uuid} isModal />
      </Modal.Body>
    </Modal>
  );
}
